export default __webpack_public_path__ + "static/media/cake2.6387825f.webp";